import React from 'react';
import { Star } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import GenAiReveal from './GenAiReveal';
import { GEN_AI_CREATIVE_LANDING } from '../../data/genAiCreativeLanding';

const GenAiCases = () => {
  const { cases } = GEN_AI_CREATIVE_LANDING;

  return (
    <section className="bg-[#ecebf2] px-5 py-16 md:px-10 md:py-20 xl:px-[100px] xl:py-[120px]">
      <div className="mx-auto max-w-[1240px]">
        <GenAiReveal>
          <h2 className="text-[32px] font-semibold leading-[1.1] text-[#0e0e0e] md:text-4xl xl:text-[48px]">
            {cases.title}
          </h2>
        </GenAiReveal>

        <GenAiReveal delay={80} className="mt-10">
          <Accordion
            type="single"
            collapsible
            defaultValue="pragmatica"
            className="flex flex-col gap-6"
          >
            {cases.items.map((item) => (
              <AccordionItem
                key={item.id}
                value={item.id}
                className="overflow-hidden rounded-3xl border border-[#d9d8e0] bg-white px-5 md:px-10"
              >
                <AccordionTrigger className="gap-4 py-8 hover:no-underline [&[data-state=open]>svg]:rotate-180">
                  <div className="flex min-w-0 flex-1 flex-col items-start gap-4 text-left">
                    <div className="flex flex-wrap items-center gap-2 md:gap-3">
                      <span className="inline-flex h-12 shrink-0 items-center rounded-xl bg-[#333] px-5">
                        <img
                          src={item.logo}
                          alt={item.company}
                          className="h-6 w-auto max-w-none object-contain object-left"
                        />
                      </span>
                      <span className="inline-flex items-center gap-2 rounded-xl border border-[#2b7afe] bg-[rgba(43,122,254,0.07)] px-4 py-2.5 text-sm font-semibold text-[#2b7afe] md:px-5 md:text-[15px]">
                        <Star className="size-4 shrink-0 fill-[#2b7afe] text-[#2b7afe]" aria-hidden />
                        {item.result}
                      </span>
                    </div>
                    <span className="text-xl font-bold leading-snug text-[#0b0b0b] md:text-[28px] xl:text-[32px]">
                      {item.title}
                    </span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="pb-8 pt-0 text-base leading-[1.3] text-[#2f2f2f]/80 md:text-lg">
                  {item.body}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </GenAiReveal>
      </div>
    </section>
  );
};

export default GenAiCases;
